import { Pencil, Unlink2 } from "lucide-react";
import type { CurvaDocument } from "@/document/model/document";
import type { DocumentStyleKind } from "@/document/model/documentStyles";
import { findDocumentStyle } from "@/document/model/documentStyles";
import { documentStyleLabel, documentStylePreviewBackground, documentStyleSummary } from "./stylePreview";

export function AppliedStyleRow({
  document,
  styleId,
  kind,
  onDetach,
  onEdit,
}: {
  document: CurvaDocument;
  styleId: string;
  kind: DocumentStyleKind;
  onDetach: () => void;
  onEdit?: () => void;
}) {
  const style = findDocumentStyle(document, styleId);
  if (!style) {
    return (
      <div className="flex items-center justify-between rounded bg-white/[0.04] px-2 py-2 text-[11px] text-slate-500">
        Missing style
        <button type="button" onClick={onDetach} className="text-slate-300 hover:text-white">
          Detach
        </button>
      </div>
    );
  }

  const summary = documentStyleSummary(document, styleId);

  return (
    <div className="flex items-center gap-2 rounded bg-white/[0.04] px-2 py-2">
      <span
        className="size-6 shrink-0 rounded-sm border border-white/20"
        style={{ background: documentStylePreviewBackground(document, style) }}
      />
      <div className="min-w-0 flex-1">
        <div className="truncate text-[12px] text-slate-100">{documentStyleLabel(style)}</div>
        {summary ? <div className="truncate text-[10px] text-slate-500">{summary}</div> : null}
      </div>
      {onEdit ? (
        <button
          type="button"
          aria-label={`Edit ${kind} style`}
          onClick={onEdit}
          className="grid size-7 shrink-0 place-items-center rounded text-slate-400 hover:bg-white/[0.06] hover:text-slate-100"
        >
          <Pencil className="size-3.5" />
        </button>
      ) : null}
      <button
        type="button"
        aria-label={`Detach ${kind} style`}
        onClick={onDetach}
        className="grid size-7 shrink-0 place-items-center rounded text-slate-400 hover:bg-white/[0.06] hover:text-slate-100"
      >
        <Unlink2 className="size-3.5" />
      </button>
    </div>
  );
}
